/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getApiCostcentersIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getApiCostcentersId200Schema = z.object({
  id: z.coerce.number().int().optional(),
  name: z.coerce.string(),
  client: z.object({
    value: z.coerce.number().int(),
    label: z.coerce.string(),
  }),
  isVisible: z.boolean(),
});

export const getApiCostcentersIdQueryResponseSchema = z.lazy(
  () => getApiCostcentersId200Schema,
);
